module.exports = __webpack_public_path__ + "img/foto-estagio-6.3a9b8bec.png";